import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import pattern from '../assets/images/pattern.png';

import Modal from '../components/Modal';
import Button from '../components/Button';
import Spinner from '../components/Spinner';

const DataEntryMobile = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
  });
  const [isModalOpen, setModalOpen] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const { t } = useTranslation();

  const { time } = useDispatch();

  const navigate = useNavigate();

  const closeModal = () => setModalOpen(false);

  const onSubmit = (e) => {
    e.preventDefault();

    const { firstName, lastName } = formData;

    if (!firstName || !lastName) return;

    setLoading(true);

    localStorage.setItem('user-info', JSON.stringify(formData));

    setFormData({ firstName: '', lastName: '' });
    setChecked(false);

    setLoading(false);

    navigate('/quiz');
  };

  useEffect(() => {
    const startTime = new Date().toLocaleString();

    time.setStartTime(startTime);

    localStorage.setItem('start-time', startTime);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="w-[100vw] h-auto relative flex flex-col overflow-y-scroll">
        <div className="_gradient-border text-[2rem] w-[80%] h-[60vh] mx-auto mt-10 z-20">
          <form className="w-full" onSubmit={onSubmit}>
            <div className="text-2xl md:p-16 px-8 mt-6 md:mt-20 z-20">
              <div className="md:flex justify-between">
                <div className="md:w-[46%] mb-4 md:mr-8 flex flex-col md:gap-2">
                  <label>{t('firstName')}</label>
                  <input
                    type="text"
                    value={formData.firstName}
                    autoFocus
                    spellCheck={false}
                    required
                    onChange={(e) => setFormData((prev) => ({ ...prev, firstName: e.target.value }))}
                    className="md:text-[1.8rem] text-black p-2 rounded-lg shadow-[inset_-5.663px_-4.114px_3px_rgba(255,255,255,0.04),inset_5.516px_4.31px_3px_rgba(0,0,0,0.09)] focus:outline-neutral-800"
                  />
                </div>
                <div className="md:w-[46%] mb-4 flex flex-col md:gap-y-2">
                  <label>{t('lastName')}</label>
                  <input
                    type="text"
                    value={formData.lastName}
                    spellCheck={false}
                    required
                    onChange={(e) => setFormData((prev) => ({ ...prev, lastName: e.target.value }))}
                    className="md:text-[1.8rem] text-black p-2 rounded-lg shadow-[inset_-5.663px_-4.114px_3px_rgba(255,255,255,0.04),inset_5.516px_4.31px_3px_rgba(0,0,0,0.09)] focus:outline-neutral-800"
                  />
                </div>
              </div>
              <div className="mt-8 relative flex items-center col-span-12">
                <input
                  type="checkbox"
                  checked={isChecked}
                  required
                  onChange={(e) => {}}
                  className="w-0 h-0 opacity-0"
                />
                <div
                  className="w-[40px] h-[40px] border-gray-200 border-[3px] rounded-2xl relative z-10 cursor-pointer"
                  onClick={() => (!isChecked ? setChecked(true) : setChecked(false))}
                >
                  <div
                    className={`bg-white w-[18px] h-[18px] rounded-[4px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] ${
                      isChecked ? 'scale-1' : 'scale-0'
                    }`}
                  ></div>
                </div>
                <div className="w-[40px] h-[40px] absolute left-0 z-20" onClick={() => setModalOpen(true)}></div>
                <div className="text-[1.2rem] text-left w-[80%] ml-4 cursor-pointer" onClick={() => setModalOpen(true)}>
                  {t('agreement1')} <span className="underline">{t('agreement2')}</span>
                </div>
              </div>
            </div>

            {isLoading ? (
              <Spinner className="w-[80px] mx-auto mt-12 mb-20" />
            ) : (
              <Button type="submit" className="mt-8 mb-16 md:mt-14 mx-auto">
                Submit
              </Button>
            )}
          </form>
        </div>

        <Modal isModalOpen={isModalOpen} closeModal={closeModal} setIsChecked={setChecked} />
      </div>

      <img src={pattern} alt="pattern" className="w-[60%] absolute bottom-0 left-0" />
    </>
  );
};

export default DataEntryMobile;
